import React, { useEffect, useState } from "react";
import axios from "axios";
import { showToast } from "../../utils/toast.js";
import { X } from "lucide-react";
const API = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const AsignarCapacitacion = ({ capacitacionInicial = null, onClose }) => {
  const [empleados, setEmpleados] = useState([]);
  const [capacitaciones, setCapacitaciones] = useState([]);
  const [empleadosSeleccionados, setEmpleadosSeleccionados] = useState([]);
  const [capacitacionSeleccionada, setCapacitacionSeleccionada] = useState(
    capacitacionInicial ? (capacitacionInicial.idcapacitacion || capacitacionInicial.id) : ""
  );
  const [showError, setShowError] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [esExterna, setEsExterna] = useState(false);
  const [fechaEntrega, setFechaEntrega] = useState("");

  const fetchEstadoInformeExterno = async (idCapacitacion) => {
    try {

      // Obtener asignaciones
      const resAsignaciones = await axios.get(
        `${API}/empleadocapacitacion/`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const asignaciones = resAsignaciones.data.results || resAsignaciones.data;

      // IDs de asignaciones de esta capacitación
      const idsAsignaciones = asignaciones
        .filter(
          a =>
            Number(a.idcapacitacion) === Number(idCapacitacion) &&
            a.estado === true
        )
        .map(a => Number(a.idempleadocapacitacion || a.id));

      // Obtener informes
      const resInformes = await axios.get(
        `${API}/informes-capacitacion/`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const informes = resInformes.data.results || resInformes.data;

      // Buscar informe relacionado
      const informe = informes.find(inf =>
        idsAsignaciones.includes(
          Number(inf.idempleadocapacitacion)
        )
      );

      if (informe) {
        setEsExterna(true);

        if (informe.fecha_entrega) {
          setFechaEntrega(informe.fecha_entrega);
        }
      } else {
        setEsExterna(false);
        setFechaEntrega("");
      }

    } catch (error) {
      console.error("Error obteniendo estado de informe:", error);
    }
  };

  useEffect(() => {
    fetchEmpleados();
    fetchCapacitaciones();

    if (capacitacionInicial) {

      const idCap =
        capacitacionInicial.idcapacitacion ||
        capacitacionInicial.id;

      fetchEmpleadosAsignados(idCap);

      fetchEstadoInformeExterno(idCap);
    }
  }, []);

  const fetchEmpleados = async () => {
    try {
      const res = await axios.get(`${API}/empleados/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEmpleados(res.data.results || res.data);
    } catch (error) {
      console.error("Error al cargar Trabajadores/as:", error);
      showToast("Error al cargar Trabajadores/as", "error");
    }
  };

  const fetchCapacitaciones = async () => {
    try {
      const res = await axios.get(`${API}/capacitaciones/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const activas = (res.data.results || res.data).filter(c => c.estado === true);
      setCapacitaciones(activas);
    } catch (error) {
      console.error("Error al cargar capacitaciones:", error);
      showToast("Error al cargar capacitaciones", "error");
    }
  };

  const fetchEmpleadosAsignados = async (idCapacitacion) => {
    try {
      const res = await axios.get(`${API}/empleadocapacitacion/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const asignaciones = res.data.results || res.data;
      const empleadosIdsAsignados = asignaciones
        .filter(a => Number(a.idcapacitacion) === Number(idCapacitacion) && a.estado === true) // Solo activos
        .map(a => Number(a.idempleado));
      setEmpleadosSeleccionados(empleadosIdsAsignados);
    } catch (error) {
      console.error("Error al cargar Trabajadores/as asignados:", error);
    }
  };

  const toggleEmpleadoSeleccionado = id => {
    setEmpleadosSeleccionados(prev =>
      prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]
    );
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!capacitacionSeleccionada) {
      setShowError(true);
      showToast("Debe seleccionar una capacitación", "warning");
      return;
    }

    setShowError(false);

    try {
      const idUsuario = Number(sessionStorage.getItem("idUsuario") || 1);

      // Obtener asignaciones existentes
      const res = await axios.get(`${API}/empleadocapacitacion/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const asignacionesExistentes = res.data.results || res.data;

      // Filtrar asignaciones activas de esta capacitación
      const asignacionesActuales = asignacionesExistentes.filter(
        asig => Number(asig.idcapacitacion) === Number(capacitacionSeleccionada) && asig.estado === true
      );

      // Validar que ningún empleado seleccionado esté asignado a otra capacitación en las mismas fechas
      const capacitacionActual = capacitaciones.find(
        c => Number(c.idcapacitacion || c.id) === Number(capacitacionSeleccionada)
      );
      if (capacitacionActual) {
        const fechaInicioActual = new Date(capacitacionActual.fechainicio);
        const fechaFinActual = new Date(capacitacionActual.fechafin);

        for (const idEmpleado of empleadosSeleccionados) {
          // Buscar asignaciones activas de este empleado en otras capacitaciones
          const otrasAsignaciones = asignacionesExistentes.filter(
            asig => Number(asig.idempleado) === Number(idEmpleado) &&
              Number(asig.idcapacitacion) !== Number(capacitacionSeleccionada) &&
              asig.estado === true
          );
          for (const asig of otrasAsignaciones) {
            const otraCap = capacitaciones.find(
              c => Number(c.idcapacitacion || c.id) === Number(asig.idcapacitacion)
            );
            if (otraCap) {
              const fechaInicioOtra = new Date(otraCap.fechainicio);
              const fechaFinOtra = new Date(otraCap.fechafin);
              // Validar si hay cruce de fechas
              if (
                (fechaInicioActual <= fechaFinOtra && fechaFinActual >= fechaInicioOtra)
              ) {
                const empleado = empleados.find(emp => (emp.idempleado || emp.id) === idEmpleado);
                showToast(`El Trabajador/a ${empleado?.nombre || ''} ${empleado?.apellido || ''} ya está asignado a otra capacitación en las mismas fechas.`, "warning");
                return;
              }
            }
          }
        }
      }

      let operacionesRealizadas = 0;

      // 1. Desactivar asignaciones que ya no están seleccionadas
      for (const asignacion of asignacionesActuales) {
        const empleadoSigueSeleccionado = empleadosSeleccionados.includes(Number(asignacion.idempleado));

        if (!empleadoSigueSeleccionado) {
          try {
            const idAsignacion = asignacion.idempleadocapacitacion || asignacion.id;

            if (idAsignacion) {
              // Usar PUT para desactivar en lugar de DELETE
              const payload = {
                ...asignacion,
                estado: false,
                idusuario: idUsuario
              };

              const resp = await axios.put(`${API}/empleadocapacitacion/${idAsignacion}/`, payload, {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              });
              operacionesRealizadas++;
            }
          } catch (error) {
            console.error(`Error al desactivar asignación:`, error);
          }
        }
      }

      // 2. Agregar nuevas asignaciones o reactivar existentes
      for (const idEmpleado of empleadosSeleccionados) {
        const asignacionExistente = asignacionesExistentes.find(
          asig => Number(asig.idempleado) === Number(idEmpleado) &&
            Number(asig.idcapacitacion) === Number(capacitacionSeleccionada)
        );

        if (asignacionExistente) {
          // Si existe pero está desactivada, reactivarla
          if (!asignacionExistente.estado) {
            try {
              const payload = {
                ...asignacionExistente,
                estado: true,
                idusuario: idUsuario
              };

              const idAsignacion = asignacionExistente.idempleadocapacitacion || asignacionExistente.id;
              await axios.put(`${API}/empleadocapacitacion/${idAsignacion}/`, payload, {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              });
              operacionesRealizadas++;

              // SI ES EXTERNA, CREAR INFORME SI NO EXISTE
              if (esExterna) {

                try {

                  // Obtener informes existentes
                  const resInformes = await axios.get(
                    `${API}/informes-capacitacion/`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`
                      }
                    }
                  );

                  const informes = resInformes.data.results || resInformes.data;

                  // Verificar si ya existe informe
                  const informeExistente = informes.find(
                    inf =>
                      Number(inf.idempleadocapacitacion) ===
                      Number(
                        asignacionExistente.idempleadocapacitacion ||
                        asignacionExistente.id
                      )
                  );

                  if (!informeExistente) {

                    const responseInforme = await axios.post(
                      `${API}/informes-capacitacion/`,
                      {
                        idempleadocapacitacion:
                          asignacionExistente.idempleadocapacitacion ||
                          asignacionExistente.id,

                        fecha_entrega: fechaEntrega,

                        estado_informe: "PENDIENTE",

                        objetivos: "",
                        tematicas_contenidos: "",
                        metodologia: "",
                        conclusiones: "",

                        aciertos_dificultades: "",
                        utilidad_formacion: "",

                        resultados_institucion: "",
                        resultados_participante: "",

                        compromiso_aplicacion: "",
                        propuesta_seguimiento: "",

                        estado: true,
                        idusuario: idUsuario
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`
                        }
                      }
                    );


                  }

                } catch (error) {

                  console.error(
                    "Error validando/creando informe:",
                    error.response?.data || error
                  );

                }
              }
            } catch (error) {
              console.error("Error al reactivar asignación:", error);
            }
          }
          // Si existe y está activa, no hacer nada
        } else {
          // No existe, crear nueva asignación
          try {
            const payload = {
              idempleado: Number(idEmpleado),
              idcapacitacion: Number(capacitacionSeleccionada),
              fechaenvio: null,
              asistencia: "no",
              idusuario: idUsuario,
              estado: true
            };

            // SOLO UN POST
            const responseAsignacion = await axios.post(
              `${API}/empleadocapacitacion/`,
              payload,
              {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }
            );

            const nuevaAsignacion = responseAsignacion.data;

            operacionesRealizadas++;

            // VALIDAR FECHA
            if (esExterna && !fechaEntrega) {
              showToast("Debe ingresar fecha límite de entrega", "warning");
              return;
            }

            // CREAR INFORME SOLO SI ES EXTERNA
            if (esExterna) {
              try {

                const responseInforme = await axios.post(
                  `${API}/informes-capacitacion/`,
                  {
                    idempleadocapacitacion:
                      nuevaAsignacion.idempleadocapacitacion ||
                      nuevaAsignacion.id,

                    fecha_entrega: fechaEntrega,

                    estado_informe: "PENDIENTE",

                    objetivos: "",
                    tematicas_contenidos: "",
                    metodologia: "",
                    conclusiones: "",

                    aciertos_dificultades: "",
                    utilidad_formacion: "",

                    resultados_institucion: "",
                    resultados_participante: "",

                    compromiso_aplicacion: "",
                    propuesta_seguimiento: "",

                    estado: true,
                    idusuario: idUsuario
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${token}`
                    }
                  }
                );

              } catch (error) {

                console.error(
                  "Error creando informe:",
                  error.response?.data || error
                );

              }
            }

          } catch (error) {
            console.error("Error al crear asignación:", error);
          }
        }
      }


      // Mostrar mensaje según el resultado
      if (operacionesRealizadas > 0) {
        showToast("Asignaciones actualizadas correctamente", "success");
        // Cerrar el modal inmediatamente después del guardado exitoso
        onClose();
      } else if (empleadosSeleccionados.length === 0 && asignacionesActuales.length === 0) {
        showToast("No hay Trabajadores/as asignados a esta capacitación", "info");
        // También cerrar inmediatamente en este caso
        onClose();
      } else {
        showToast("No se realizaron cambios", "info");
        // En este caso no cerrar porque no hubo cambios reales
      }

      // Refrescar Trabajadores asignados
      fetchEmpleadosAsignados(capacitacionSeleccionada);
    } catch (error) {
      console.error(error);
      showToast("Error al actualizar asignaciones", "error");
    }
  };

  const empleadosFiltrados = empleados.filter(emp => {
    // Solo mostrar empleados activos
    if (!(emp.estado === true || emp.estado === 1)) return false;
    const nombreCompleto = `${emp.nombre} ${emp.apellido}`.toLowerCase();
    return nombreCompleto.includes(busqueda.toLowerCase());
  });

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-15%, -50%)",
        width: "500px",
        maxWidth: "95%",
        background: "#fff",
        padding: "30px",
        boxShadow: "0 0 20px rgba(0,0,0,0.2)",
        borderRadius: "12px",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column"
      }}
    >
      <h3 style={{ textAlign: "center", marginBottom: "20px" }}>Asignar Trabajadores/as</h3>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        {/* Capacitación */}
        {capacitacionInicial ? (
          <div
            style={{
              padding: "12px",
              backgroundColor: "#e3f2fd",
              border: "1px solid #2196f3",
              borderRadius: "6px",
              marginBottom: "10px"
            }}
          >
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "bold", color: "#1976d2" }}>
              Capacitación seleccionada:
            </label>
            <div style={{ fontSize: "16px", color: "#0d47a1" }}>
              {capacitacionInicial.nombreevento}
            </div>
          </div>
        ) : (
          <div>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Seleccione una capacitación <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={capacitacionSeleccionada}
              onChange={e => setCapacitacionSeleccionada(e.target.value)}
              required
              style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
            >
              <option value="">Seleccione una capacitación</option>
              {capacitaciones.map(cap => (
                <option key={cap.idcapacitacion || cap.id} value={cap.idcapacitacion || cap.id}>
                  {cap.nombreevento}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Capacitación Externa */}
        <div
          style={{
            padding: "12px",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            backgroundColor: "#f9fafb"
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              fontWeight: "500"
            }}
          >
            <input
              type="checkbox"
              checked={esExterna}
              onChange={(e) => setEsExterna(e.target.checked)}
              style={{
                width: "16px",
                height: "16px"
              }}
            />

            Esta capacitación requiere informe externo
          </label>

          {esExterna && (
            <div style={{ marginTop: "15px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px"
                }}
              >
                Fecha límite de entrega
              </label>

              <input
                type="date"
                value={fechaEntrega}
                onChange={(e) => setFechaEntrega(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc"
                }}
              />
            </div>
          )}
        </div>

        {/* Trabajadores seleccionados */}
        {empleadosSeleccionados.length > 0 && (
          <div style={{
            marginBottom: "20px"
          }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px"
            }}>
              <div style={{
                fontSize: "14px",
                color: "#6b7280",
                fontWeight: "400"
              }}>
                Trabajadores/as seleccionados ({empleadosSeleccionados.length}):
              </div>
              <button
                type="button"
                onClick={() => setEmpleadosSeleccionados([])}
                style={{
                  backgroundColor: "transparent",
                  color: "#6b7280",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "400",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f9fafb";
                  e.target.style.color = "#374151";
                  e.target.style.borderColor = "#9ca3af";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6b7280";
                  e.target.style.borderColor = "#d1d5db";
                }}
                title="Quitar todos los Trabajadores/as"
              >
                Limpiar selección
              </button>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {empleadosSeleccionados.map(idEmpleado => {
                const empleado = empleados.find(emp => (emp.idempleado || emp.id) === idEmpleado);
                return empleado ? (
                  <span
                    key={idEmpleado}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      backgroundColor: "#e1f5fe",
                      color: "#01579b",
                      padding: "6px 12px",
                      borderRadius: "16px",
                      fontSize: "13px",
                      fontWeight: "400",
                      border: "1px solid #b3e5fc"
                    }}
                  >
                    {empleado.nombre} {empleado.apellido}
                    <button
                      type="button"
                      onClick={() => toggleEmpleadoSeleccionado(idEmpleado)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#01579b",
                        cursor: "pointer",
                        padding: "0",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        fontWeight: "normal",
                        lineHeight: "1"
                      }}
                      title="Quitar Trabajador/a"
                    >
                      ×
                    </button>
                  </span>
                ) : null;
              })}
            </div>
          </div>
        )}

        {/* Trabajadores */}
        <div>
          <label style={{ display: "block", marginBottom: "6px" }}>
            Seleccione Trabajadores/as
          </label>

          <div
            style={{
              border: `1px solid #ccc`,
              borderRadius: "6px",
              backgroundColor: "#f9fafb"
            }}
          >
            <input
              type="text"
              placeholder="Buscar por nombre o apellido..."
              value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                border: "none",
                borderBottom: "1px solid #e5e5e5",
                borderRadius: "6px 6px 0 0",
                outline: "none",
                backgroundColor: "#fff"
              }}
            />

            <div style={{ maxHeight: "150px", overflowY: "auto", padding: "8px" }}>
              {empleadosFiltrados.length > 0 ? (
                empleadosFiltrados.map(emp => (
                  <label
                    key={emp.idempleado || emp.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "8px 6px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      transition: "background-color 0.2s",
                      backgroundColor: empleadosSeleccionados.includes(emp.idempleado || emp.id)
                        ? "#e3f2fd" : "transparent"
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={empleadosSeleccionados.includes(emp.idempleado || emp.id)}
                      onChange={() => toggleEmpleadoSeleccionado(emp.idempleado || emp.id)}
                      style={{ width: "16px", height: "16px", accentColor: "#2196f3" }}
                    />
                    <span style={{ fontSize: "14px", fontWeight: empleadosSeleccionados.includes(emp.idempleado || emp.id) ? "500" : "normal" }}>
                      {emp.nombre} {emp.apellido}
                    </span>
                  </label>
                ))
              ) : (
                <div style={{ padding: "20px", textAlign: "center", color: "#777", fontSize: "14px" }}>
                  {busqueda ? "No se encontraron Trabajadores/as con ese nombre" : "No hay Trabajadores/as disponibles"}
                </div>
              )}
            </div>
          </div>
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            background: "#219ebc",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Guardar
        </button>

        <button
          onClick={onClose}
          style={{ position: "absolute", top: "10px", right: "15px", background: "transparent", border: "none", cursor: "pointer" }}
          title="Cerrar"
          type="button"
        >
          <X size={24} color="#555" />
        </button>
      </form>
    </div>
  );
};

export default AsignarCapacitacion;
